import { render, staticRenderFns } from "./PengajuanCreate.vue?vue&type=template&id=d2791f7a"
import script from "./PengajuanCreate.vue?vue&type=script&lang=js"
export * from "./PengajuanCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports